import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchUserCurrentLocationData,
  LoginTheAdmin,
  verifyLoginTokenAdmin,
  verifyLoginTokenUser,
} from "../../Apis/User-Apis";
import {
  getLocalStorageJSON,
  removeLocalStorageJSON,
  setLocalStorageJSON,
} from "../../../Utils/localStorageFunc";

let searchParamsUser = {
  name: "India",
  code: "IN",
  currency: "INR",
  dial_code: "+91",
};

const initialState = {
  status: "loading",
  userData: null,
  UserCurrentLocationData: searchParamsUser,
  isOffline: false,
  userLoading : true,
  userLoggedInData: null,
  isUserLogin: false,
  isAdminLogin: false,
  showSignUpPopup: false,
  isSignUpCrossed: false,
};

// Async thunk to fetch user current location data
export const UserLocationFetcher = createAsyncThunk(
  "user/fetchUserLocationData",
  async () => {
    try {
      const response = await fetchUserCurrentLocationData();
      // The value we return becomes the `fulfilled` action payload
      return response;
    } catch (error) {
      console.log("the rror : ", error);
      throw error;
    }
  }
);

export const AuthenticateUser = () => {
  return async (dispatch, getState) => {
    const statesData = getState();

    let { user } = statesData;

    let state = user;
    console.log("the states are  : ", state);

    let ul = getLocalStorageJSON("UL");
    let al = getLocalStorageJSON("AL");

    const urlParams = new URLSearchParams(window.location.search);

    const email = urlParams.get("em");
    const password = urlParams.get("ps");

    let adminChecker = async (email, password) => {
      let resp = await LoginTheAdmin({ email, password });

      if (resp.error == false) {
        // set token and related things
        dispatch(setUserLoggedInData(resp.data.admin));
        removeLocalStorageJSON("UL");
        setLocalStorageJSON("AL", resp.data.token);
        dispatch(setisUserLogin(false));
        dispatch(setisAdminLogin(true));
        dispatch(setUserLoading(false))

        return true;
      }
      return false;
    };

    console.log("ul is : ", ul);
    console.log("al is : ", al);

    if (ul == null && al == null) {
      // not login in past history

      if (email && password) {
        let move = await adminChecker(email, password);

        if (move == false) {
          removeLocalStorageJSON("UL");
          removeLocalStorageJSON("AL");
          dispatch(setisUserLogin(false));
          dispatch(setisAdminLogin(false));
          dispatch(setUserLoggedInData(null));
          // dispatch(setShowSignUpPopup(true));
          dispatch(setShowSignUpPopup(false));
          dispatch(setUserLoading(false))
        }
      } else {
        removeLocalStorageJSON("UL");
        removeLocalStorageJSON("AL");
        dispatch(setisUserLogin(false));
        dispatch(setisAdminLogin(false));
        dispatch(setUserLoggedInData(null));
        dispatch(setUserLoading(false))
        // dispatch(setShowSignUpPopup(true));
        dispatch(setShowSignUpPopup(false));
      }

      // User has not logged in before
    } else {
      // automatic login

      if (ul != null) {
        // call user authenticator

        const isTokenValid = await verifyLoginTokenUser(ul);
        console.log("isTokenValid is : ", isTokenValid);

        if (isTokenValid[0] == false) {
          // User has not logged in before
          if (!(email && password)) {
            // dispatch(setShowSignUpPopup(true));
            dispatch(setShowSignUpPopup(false));
          }
          removeLocalStorageJSON("UL");
          removeLocalStorageJSON("AL");
        } else {
          dispatch(setisUserLogin(true));
          dispatch(setisAdminLogin(false));
          dispatch(setUserLoggedInData(isTokenValid[1]));
          dispatch(setUserLoading(false))
        }
      } else if (al != null) {
        // call admin authenticator

        const isTokenValid = await verifyLoginTokenAdmin(al);

        if (isTokenValid[0] == false) {
          if (!(email && password)) {
            // dispatch(setShowSignUpPopup(true));
            dispatch(setShowSignUpPopup(false));
          }
          removeLocalStorageJSON("UL");
          removeLocalStorageJSON("AL");
        } else {
          dispatch(setisUserLogin(false));
          dispatch(setisAdminLogin(true));
          dispatch(setUserLoggedInData(isTokenValid[1]));
          dispatch(setUserLoading(false))
        }
      }
    }
  };
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    // admina nd suer can login from same very end  ... on case of both logins create localstorage identifier AL / UL as true or false and authenticate through token by them

    setShowSignUpPopup: (state, action) => {
      state.showSignUpPopup = action.payload;
    },
    setUserLoggedInData: (state, action) => {
      state.userLoggedInData = action.payload;
    },
    setUserLoading: (state, action) => {
      state.userLoading = action.payload;
    },
    setisUserLogin: (state, action) => {
      state.isUserLogin = action.payload;
    },
    setisAdminLogin: (state, action) => {
      state.isAdminLogin = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(UserLocationFetcher.pending, (state) => {
        state.status = "loading";
      })
      .addCase(UserLocationFetcher.fulfilled, (state, action) => {
        state.status = "idle";
        state.UserCurrentLocationData = {
          name: action.payload.country_name,
          code: action.payload.country,
          currency: action.payload.currency,
          dial_code: action.payload.country_calling_code,
        };
      })
      .addCase(UserLocationFetcher.rejected, (state, action) => {
        console.log("the erorr here is : ", action);
        state.status = "idle";

        if (action.error.message === "Failed to fetch") {
          state.isOffline = true;
        }
      });
  },
});

export const {
  setShowSignUpPopup,
  setUserLoading,
  setUserLoggedInData,
  setisUserLogin,
  setisAdminLogin,
} = userSlice.actions;

export default userSlice.reducer;
